const TermsAndConditions = "https://www.icarehealthplan.org/terms";
const PrivacyPolicy = "https://www.icarehealthplan.org/Utility-Navigation/Privacy-Policy.htm";

export { TermsAndConditions, PrivacyPolicy };